import {gql} from "@apollo/client";

export const GET_PAGINATED_CART_ITEM_QUERY = gql`
  query {
    getPaginatedCartItem {
      data {
        id
        service {
          id
          name
          description
          fields {
            id
            name
            type
            inputFieldName
            multipleInputFieldName
            isRequired
            isHidden
            ioType
            cluster
          }
          clusters {
            id
            name
            isHidden
            isRepeatable
          }
          criticalDeadline {
            from
            to
            value
          }
        }
        customer {
          id
          firstName
          lastName
        }
      }
      errors {
        message
      }
    }
  }
`;

export const AUTOCOMPLETE_PUBLIC_SERVICES_QUERY = gql`
  query ($search: String) {
    autoCompletePublicServices(search: $search) {
      data {
        id
        name
        isFeatured
        category {
          id
          name
        }
      }
      errors {
        message
      }
    }
  }
`;

export const GET_PAGINATED_CLIENT_TYPE = gql`
  query ($order: String, $field: String!, $offset: Int!, $limit: Int!) {
    getPaginatedClientType(
      order: $order
      field: $field
      offset: $offset
      limit: $limit
    ) {
      type {
        id
        name
        isVisible
        clients {
          id
        }
      }
      count
      errors {
        message
      }
    }
  }
`;

export const GET_MY_AGENCY = gql`
  query {
    getMyAgency {
      errors {
        message
      }
      client {
        fiscalCode
        discount
        expiresAt
      }
    }
  }
`;

export const GET_MY_AGENCY_DETAILS = gql`
  query {
    getMyAgency {
      errors {
        message
      }
      client {
        id
        name
        representative
        documentNumber
        companyTypeId
        documentTypeId
        expiresAt
        firstName
        lastName
        businessName
        fiscalCode
        vatNumber
        address
        houseNumber
        postalCode
        city
        province
        pecEmail
        sdiEmail
        email
        pecEmailAddress
        documents
        discount
        municipalityId
        regionId
        streetId
        dylogType
      }
    }
  }
`;

export const GET_MY_DETAIL = gql`
  query {
    getMyDetail {
      errors {
        message
      }
      customer {
        id
        firstName
        lastName
        mobileNumber
        notifiedBy
        email
        acceptedTerms
      }
    }
  }
`;

export const GET_PAGINATED_ESTIMATES_MESSAGES_QUERY = gql`
  query (
    $order: String
    $field: String!
    $offset: Int!
    $limit: Int!
    $search: String
    $estimateId: ID!
  ) {
    getPaginatedEstimateMessage(
      order: $order
      field: $field
      offset: $offset
      limit: $limit
      search: $search
      estimateId: $estimateId
    ) {
      errors {
        message
      }
      estimateMessage {
        id
        message
        documents
        customer {
          id
          lastName
          firstName
        }
        admin {
          id
          lastName
          firstName
        }
        isSeen
      }
    }
  }
`;

export const GET_PAGINATED_ORDERS_MESSAGES_QUERY = gql`
  query (
    $order: String
    $field: String!
    $offset: Int!
    $limit: Int!
    $search: String
    $orderId: Int!
  ) {
    getPaginatedOrderMessage(
      order: $order
      field: $field
      offset: $offset
      limit: $limit
      search: $search
      orderId: $orderId
    ) {
      errors {
        message
      }
      data {
        id
        message
        documents
        customer {
          id
          lastName
          firstName
        }
        admin {
          id
          lastName
          firstName
        }
        orderId
        createdAt
        isSeen
        isMailSent
      }
    }
  }
`;
